import React from "react";
import { useNavigate } from "react-router";

function RFOMain() {
  const navigate = useNavigate();

  const handleStartOptimizing = () => {
    navigate("/ResumeFitOptimizer/UploadResume");
  };
  return (
    <>
      <div className="ResumeFitOptimizer-contentainer d-flex flex-column gap-2">
        <div className="ResumeFitOptimizer-grid-parent h-100">
          <div class="div1">
            <h1 className="mb-4">
              Optimize Your <span className="color-blue">Resume</span> with AI
            </h1>
            <p className="mb-4">
              Boost your chances of landing interviews with our AI-powered
              Resume Fit Optimizer. Tailored improvements for your dream job.
            </p>
            <div className="d-flex justify-content-center flex-column align-items-center">
            <button
              className="d-flex align-items-center gap-2 justify-content-center mb-2"
              onClick={handleStartOptimizing}
            >
              Start Optimizing{" "}
              <svg
                width="20"
                height="14"
                viewBox="0 0 24 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.2696 0.66963C13.5696 0.369676 13.9765 0.201172 14.4008 0.201172C14.825 0.201172 15.2319 0.369676 15.532 0.66963L22.732 7.86963C23.0319 8.16967 23.2004 8.57657 23.2004 9.00083C23.2004 9.42509 23.0319 9.83199 22.732 10.132L15.532 17.332C15.2302 17.6235 14.8261 17.7848 14.4065 17.7811C13.987 17.7775 13.5857 17.6092 13.2891 17.3125C12.9924 17.0159 12.8241 16.6146 12.8205 16.1951C12.8169 15.7756 12.9781 15.3714 13.2696 15.0696L17.6008 10.6008H2.40078C1.97643 10.6008 1.56947 10.4323 1.26941 10.1322C0.969352 9.83214 0.800781 9.42518 0.800781 9.00083C0.800781 8.57648 0.969352 8.16952 1.26941 7.86946C1.56947 7.5694 1.97643 7.40083 2.40078 7.40083H17.6008L13.2696 2.93203C12.9696 2.63199 12.8011 2.22509 12.8011 1.80083C12.8011 1.37657 12.9696 0.969674 13.2696 0.66963Z"
                  fill="white"
                />
              </svg>
            </button>
<i>"Click here to begin the resume fit optimizer process." </i>
            </div>

          </div>
          <div class="div2">
            <h4 className="text-center color-blue">How It Works</h4>
            <div className="d-flex justify-content-center align-items-center gap-4">
              <div>
                <div className="svg-container-icon">
                  {/* upload Icon */}
                  <svg
                    width="27"
                    height="27"
                    viewBox="0 0 27 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.5 7.59375C14.0594 7.59375 14.596 7.37151 14.9916 6.97593C15.3871 6.58034 15.6094 6.04382 15.6094 5.48438C15.6094 4.92493 15.3871 4.38841 14.9916 3.99282C14.596 3.59724 14.0594 3.375 13.5 3.375C12.9406 3.375 12.404 3.59724 12.0084 3.99282C11.6129 4.38841 11.3906 4.92493 11.3906 5.48438C11.3906 6.04382 11.6129 6.58034 12.0084 6.97593C12.404 7.37151 12.9406 7.59375 13.5 7.59375Z"
                      fill="#F46A05"
                    />
                    <path
                      d="M13.5 7.59375C14.5074 7.59375 15.4069 8.23838 15.7275 9.19519L15.8743 9.63394C15.8934 9.69006 15.8989 9.74995 15.8901 9.80859C15.8814 9.86724 15.8587 9.92293 15.824 9.97101C15.7893 10.0191 15.7436 10.0582 15.6907 10.085C15.6378 10.1117 15.5792 10.1255 15.5199 10.125H11.4868C11.4278 10.1247 11.3696 10.1105 11.3171 10.0835C11.2646 10.0565 11.2193 10.0175 11.1847 9.96961C11.1502 9.92173 11.1274 9.86637 11.1183 9.80804C11.1093 9.74971 11.1141 9.69005 11.1324 9.63394L11.2793 9.19519C11.4355 8.72824 11.7347 8.32229 12.1345 8.03486C12.5343 7.74744 13.0144 7.59311 13.5067 7.59375H13.5ZM8.4375 14.3438C8.4375 14.12 8.5264 13.9054 8.68463 13.7471C8.84286 13.5889 9.05747 13.5 9.28125 13.5H17.7188C17.9425 13.5 18.1571 13.5889 18.3154 13.7471C18.4736 13.9054 18.5625 14.12 18.5625 14.3438C18.5625 14.5675 18.4736 14.7821 18.3154 14.9404C18.1571 15.0986 17.9425 15.1875 17.7188 15.1875H9.28125C9.05747 15.1875 8.84286 15.0986 8.68463 14.9404C8.5264 14.7821 8.4375 14.5675 8.4375 14.3438ZM8.4375 17.7188C8.4375 17.495 8.5264 17.2804 8.68463 17.1221C8.84286 16.9639 9.05747 16.875 9.28125 16.875H17.7188C17.9425 16.875 18.1571 16.9639 18.3154 17.1221C18.4736 17.2804 18.5625 17.495 18.5625 17.7188C18.5625 17.9425 18.4736 18.1571 18.3154 18.3154C18.1571 18.4736 17.9425 18.5625 17.7188 18.5625H9.28125C9.05747 18.5625 8.84286 18.4736 8.68463 18.3154C8.5264 18.1571 8.4375 17.9425 8.4375 17.7188ZM9.28125 20.25C9.05747 20.25 8.84286 20.3389 8.68463 20.4971C8.5264 20.6554 8.4375 20.87 8.4375 21.0938C8.4375 21.3175 8.5264 21.5321 8.68463 21.6904C8.84286 21.8486 9.05747 21.9375 9.28125 21.9375H12.6562C12.88 21.9375 13.0946 21.8486 13.2529 21.6904C13.4111 21.5321 13.5 21.3175 13.5 21.0938C13.5 20.87 13.4111 20.6554 13.2529 20.4971C13.0946 20.3389 12.88 20.25 12.6562 20.25H9.28125Z"
                      fill="#F46A05"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.93072 2.7683C3.37891 3.85167 3.37891 5.2658 3.37891 8.1008V18.9008C3.37891 21.7358 3.37891 23.1533 3.93072 24.2333C4.4178 25.1836 5.19107 25.9568 6.14134 26.4439C7.22472 26.9957 8.63884 26.9957 11.4738 26.9957H15.5238C18.3588 26.9957 19.7763 26.9957 20.8563 26.4439C21.808 25.9587 22.5818 25.1849 23.067 24.2333C23.6188 23.1499 23.6188 21.7358 23.6188 18.9008V8.1008C23.6188 5.2658 23.6188 3.8483 23.067 2.7683C22.5818 1.81665 21.808 1.04287 20.8563 0.557672C19.773 0.00585943 18.3588 0.00585938 15.5238 0.00585938H11.4738C8.63884 0.00585938 7.22134 0.00585943 6.14134 0.557672C5.19107 1.04475 4.4178 1.81802 3.93072 2.7683ZM15.5238 1.69167H11.4738C10.0277 1.69167 9.04384 1.69167 8.28447 1.7558C7.54534 1.81486 7.16566 1.92455 6.90241 2.05955C6.26739 2.38311 5.7511 2.8994 5.42753 3.53442C5.29253 3.79767 5.18284 4.17567 5.12378 4.91648C5.06134 5.67586 5.05966 6.65461 5.05966 8.10586V18.9059C5.05966 20.352 5.06134 21.3359 5.12378 22.0952C5.18453 22.8344 5.29422 23.214 5.42753 23.4773C5.75153 24.1118 6.26791 24.6282 6.90241 24.9522C7.16566 25.0872 7.54534 25.1969 8.28447 25.2559C9.04384 25.3167 10.0226 25.3184 11.4738 25.3184H15.5238C16.97 25.3184 17.9538 25.3184 18.7132 25.2559C19.4523 25.1952 19.832 25.0855 20.0953 24.9522C20.7298 24.6282 21.2462 24.1118 21.5702 23.4773C21.7052 23.214 21.8148 22.8344 21.8739 22.0935C21.9363 21.3342 21.938 20.3554 21.938 18.9042V8.10417C21.938 6.65967 21.9363 5.67417 21.8739 4.9148C21.8132 4.17736 21.7035 3.79767 21.5702 3.53442C21.2466 2.8994 20.7303 2.38311 20.0953 2.05955C19.832 1.92455 19.4523 1.81486 18.7132 1.7558C17.9538 1.69336 16.9751 1.69167 15.5238 1.69167Z"
                      fill="#F46A05"
                    />
                  </svg>
                </div>
                <div className="how-it-works-content">
                  <b>1. Upload</b>
                  <br />

                  <small>Resume & Job Description</small>
                </div>
              </div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.2696 3.66963C13.5696 3.36968 13.9765 3.20117 14.4008 3.20117C14.825 3.20117 15.2319 3.36968 15.532 3.66963L22.732 10.8696C23.0319 11.1697 23.2004 11.5766 23.2004 12.0008C23.2004 12.4251 23.0319 12.832 22.732 13.132L15.532 20.332C15.2302 20.6235 14.8261 20.7848 14.4065 20.7811C13.987 20.7775 13.5857 20.6092 13.2891 20.3125C12.9924 20.0159 12.8241 19.6146 12.8205 19.1951C12.8169 18.7756 12.9781 18.3714 13.2696 18.0696L17.6008 13.6008H2.40078C1.97643 13.6008 1.56947 13.4323 1.26941 13.1322C0.969352 12.8321 0.800781 12.4252 0.800781 12.0008C0.800781 11.5765 0.969352 11.1695 1.26941 10.8695C1.56947 10.5694 1.97643 10.4008 2.40078 10.4008H17.6008L13.2696 5.93203C12.9696 5.63199 12.8011 5.22509 12.8011 4.80083C12.8011 4.37657 12.9696 3.96967 13.2696 3.66963Z"
                  fill="#686868"
                />
              </svg>

              <div>
                <div className="svg-container-icon">
                  <svg
                    width="27"
                    height="28"
                    viewBox="0 0 27 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.08828 1L15.7047 6.88125L23.0798 2.55118L19.3805 10.557L25.9969 16.4383L17.175 15.7031L13.8668 23.0547L12.0289 14.968L3.20703 14.2328L10.932 9.56457L9.08828 1Z"
                      stroke="#F46A05"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M1 26.0108L12.0273 14.9688"
                      stroke="#F46A05"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div className="how-it-works-content">
                  <b>2. Optimize</b>
                  <br />

                  <small>Receive detailed optimized resume</small>
                </div>
              </div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.2696 3.66963C13.5696 3.36968 13.9765 3.20117 14.4008 3.20117C14.825 3.20117 15.2319 3.36968 15.532 3.66963L22.732 10.8696C23.0319 11.1697 23.2004 11.5766 23.2004 12.0008C23.2004 12.4251 23.0319 12.832 22.732 13.132L15.532 20.332C15.2302 20.6235 14.8261 20.7848 14.4065 20.7811C13.987 20.7775 13.5857 20.6092 13.2891 20.3125C12.9924 20.0159 12.8241 19.6146 12.8205 19.1951C12.8169 18.7756 12.9781 18.3714 13.2696 18.0696L17.6008 13.6008H2.40078C1.97643 13.6008 1.56947 13.4323 1.26941 13.1322C0.969352 12.8321 0.800781 12.4252 0.800781 12.0008C0.800781 11.5765 0.969352 11.1695 1.26941 10.8695C1.56947 10.5694 1.97643 10.4008 2.40078 10.4008H17.6008L13.2696 5.93203C12.9696 5.63199 12.8011 5.22509 12.8011 4.80083C12.8011 4.37657 12.9696 3.96967 13.2696 3.66963Z"
                  fill="#686868"
                />
              </svg>

              <div>
                <div className="svg-container-icon">
                  <svg
                    width="22"
                    height="27"
                    viewBox="0 0 22 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 1H14.3333V11H18.5L11 18.5M11 1H7.66667V11H3.5L11 18.5"
                      stroke="#F46A05"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M1 26H21"
                      stroke="#F46A05"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="how-it-works-content">
                  <b>3. Download</b>
                  <br />
                  <small>Export enhanced resume </small>
                </div>
              </div>
            </div>
          </div>
          <div class="div3 d-flex align-items-start gap-3 justify-content-start flex-column">
            <svg
              width="28"
              height="30"
              viewBox="0 0 28 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.3938 12.9637L12.0838 28.1138C11.6057 28.6197 10.9679 28.9454 10.2777 29.0359C9.58751 29.1265 8.88723 28.9763 8.29485 28.6107C7.70248 28.2452 7.25423 27.6866 7.02566 27.0291C6.79709 26.3716 6.80216 25.6554 7.04003 25.0012L9.31253 18.75H4.01941C3.50552 18.75 2.99946 18.6241 2.54553 18.3832C2.09159 18.1423 1.70361 17.7939 1.41553 17.3683C1.12745 16.9428 0.948064 16.4531 0.893063 15.9422C0.838061 15.4312 0.909124 14.9146 1.10003 14.4375L5.45566 3.54938C5.76486 2.7791 6.29728 2.11885 6.98454 1.65343C7.6718 1.18802 8.48251 0.938701 9.31253 0.9375H16.8125C18.6275 0.9375 19.8819 2.75062 19.2463 4.44937L17.75 8.4375H24.4419C24.9662 8.43748 25.4789 8.59104 25.9169 8.87921C26.3548 9.16738 26.6988 9.57754 26.9062 10.059C27.1136 10.5405 27.1755 11.0722 27.0841 11.5884C26.9927 12.1046 26.7539 12.5828 26.3938 12.9637Z"
                fill="#F46A05"
              />
            </svg>
            <b>
              AI <span className="color-blue">Optimization & Analysis</span>{" "}
            </b>
            <small>
              Our AI aligns your resume with job requirements for maximum
              relevance.
            </small>
          </div>
          <div class="div4  d-flex align-items-start gap-3 justify-content-start flex-column">
            <svg
              width="28"
              height="28"
              viewBox="0 0 43 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.3"
                d="M16.125 32.25C22.0554 32.25 26.875 27.4304 26.875 21.5C26.875 15.5696 22.0554 10.75 16.125 10.75C10.1946 10.75 5.375 15.5696 5.375 21.5C5.375 27.4304 10.1946 32.25 16.125 32.25Z"
                fill="#F46A05"
              />
              <path
                d="M16.1263 35.8327C24.0455 35.8327 30.4596 29.4185 30.4596 21.4993C30.4596 13.5802 24.0455 7.16602 16.1263 7.16602C8.20714 7.16602 1.79297 13.5802 1.79297 21.4993C1.79297 29.4185 8.20714 35.8327 16.1263 35.8327ZM16.1263 10.7493C22.0567 10.7493 26.8763 15.5689 26.8763 21.4993C26.8763 27.4298 22.0567 32.2493 16.1263 32.2493C10.1959 32.2493 5.3763 27.4298 5.3763 21.4993C5.3763 15.5689 10.1959 10.7493 16.1263 10.7493ZM30.4596 7.63185V11.3764C32.5552 12.1143 34.3702 13.4843 35.6541 15.2975C36.9379 17.1107 37.6274 19.2776 37.6274 21.4993C37.6274 23.7211 36.9379 25.888 35.6541 27.7012C34.3702 29.5144 32.5552 30.8844 30.4596 31.6223V35.3668C36.6409 33.7723 41.2096 28.1823 41.2096 21.4993C41.2096 14.8164 36.6409 9.22643 30.4596 7.63185Z"
                fill="#F46A05"
              />
            </svg>

            <b>
              Keyword <span className="color-blue">Matching</span>{" "}
            </b>
            <small>
              Enhanced content, structure and suggestions to im prove your
              resume quickly.
            </small>
          </div>
        </div>
      </div>
    </>
  );
}

export default RFOMain;
